module.exports = __webpack_public_path__ + "assets/img/1-2-en.557bd271.png";